import React from 'react'
import * as MuiIcons from '@mui/icons-material'

const getIconNames = (iconName) => {
  if (!iconName) {
    return []
  }

  if (Array.isArray(iconName)) {
    return iconName
  }

  return String(iconName)
    .split(',')
    .map(iconNameItem => iconNameItem.trim())
    .filter(iconNameItem => !!iconNameItem)
}

const flagExistIcon = (iconName) => {
  const iconNames = getIconNames(iconName)

  return iconNames.some(iconNameItem => {
    const Icon = MuiIcons[iconNameItem]
    return !!Icon
  })
}

const useDynamicIcon = (iconName) => {
  const iconNames = getIconNames(iconName)

  return iconNames
    .map(iconNameItem => MuiIcons[iconNameItem])
    .filter(Icon => !!Icon)
}

const UseDynamicIcon = (props) => {
  const { iconName, ...rest } = props

  const Icons = useDynamicIcon(iconName)

  if (Icons.length < 1) {
    return null
  }

  return (
    <>
      {Icons.map((Icon, position) => (
        <Icon
          key={`${String(iconName)}-${position}`}
          {...rest}
        />
      ))}
    </>
  )
}

export { useDynamicIcon, flagExistIcon }
export default UseDynamicIcon
